import { Link } from "react-router-dom";

export default function BrandWordmark({ siteTitle, variant = "header" }) {
  const parts = (siteTitle || "").trim().split(" ").filter(Boolean);
  const firstWord = parts.length > 1 ? parts[0] : "";
  const restTitle = parts.length > 1 ? parts.slice(1).join(" ") : siteTitle || "";

  const capsSize =
    variant === "footer"
      ? "text-2xl tracking-[0.03em]"
      : "text-2xl sm:text-3xl md:text-4xl tracking-[0.03em]";
  const aSize = variant === "footer" ? "text-[1.1em]" : "text-[1.05em]";
  const lineW = variant === "footer" ? "w-10" : "flex-1";
  const flankBase = variant === "footer" ? "opacity-60" : "opacity-100";

  const CrestLine = ({ side }) => (
    <span
      aria-hidden="true"
      className={`flex items-center ${variant === "header" ? "flex-1" : ""} ${flankBase} group-hover:opacity-100 transition-opacity duration-500 ${
        side === "left" ? "mr-3 md:mr-5" : "ml-3 md:ml-5"
      }`}
    >
      {side === "right" && <span className="text-[8px] text-gold select-none">◆</span>}
      <span
        className={`h-px ${lineW} ${
          side === "left"
            ? "bg-gradient-to-r from-transparent via-gold to-gold"
            : "bg-gradient-to-l from-transparent via-gold to-gold"
        }`}
      />
      <span className={`text-[11px] text-gold select-none ${side === "left" ? "ml-1.5" : "mr-1.5"}`}>◆</span>
    </span>
  );

  return (
    <Link
      to="/"
      data-testid="nav-home-link"
      className={`group relative inline-flex items-center shrink-0 py-1 normal-case transition-transform duration-500 hover:scale-[1.01] ${variant === "header" ? "w-full" : ""}`}
    >
      <CrestLine side="left" />
      <span className="inline-flex items-baseline">
        {firstWord && (
          <span
            className={`font-display italic font-light text-gold/90 ${aSize} mr-1.5 leading-none group-hover:text-gold transition-colors duration-500`}
          >
            {firstWord}
          </span>
        )}
        <span className={`font-display font-light ${capsSize} transition-all duration-500 group-hover:drop-shadow-[0_2px_12px_rgba(212,175,55,0.35)]`}>
          <span className="metal-text">{restTitle}</span>
        </span>
      </span>
      <CrestLine side="right" />
    </Link>
  );
}
